import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Home", -1)
const _hoisted_2 = { class: "list" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "なんかまちがってたら各自の頭の中で補完してください m(_ _)m", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_page = _resolveComponent("page")!

  return (_openBlock(), _createBlock(_component_page, null, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("ul", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reference, (_, object) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: object }, [
            (object.startsWith('WebGL'))
              ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
                  _createVNode(_component_router_link, {
                    to: { name: 'Object', params: { objectName: object } }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(object), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ]),
      _hoisted_4
    ]),
    _: 1
  }))
}